import { Avatar, Box, Button, Card, CardContent, Chip, Divider, Typography, useTheme } from '@mui/material'
import { ORDER_TYPES, useOrder } from 'context/OrderContext'
import React from 'react'
import "./style.css";
import PersonIcon from "@mui/icons-material/Person"
import TableRestaurantOutlinedIcon from '@mui/icons-material/TableRestaurantOutlined';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import CustomTypography from 'components/Fileds/CustomTypography';

const CustomerInfoCard = ({ orderType, customerData }) => {
    const { reopenDialog } = useOrder();
    const theme = useTheme();
    return (
        <Card
            variant="outlined"
            className='customer-card-info'
        // sx={{
        //     height: orderType === ORDER_TYPES.TABLE_BOOKING ? "125px" : orderType === ORDER_TYPES.DINE_IN ? "100px" : "65px",
        // }}
        >
            <CardContent sx={{ p: 0, paddingBottom: "0px !important", width: "100%" }}>
                <Box className='d-flex align-items-center justify-content-between'>
                    {/* Left: Avatar + Name / Phone */}
                    <Box className='d-flex align-items-center'>
                        {/* <Avatar
                            sx={{
                                bgcolor: '#4D4D4D',
                                width: 36,
                                height: 36,
                                mr: 2,
                            }}
                        >
                            {customerData?.customer_name?.charAt(0)}
                        </Avatar> */}
                        <Box>
                            <CustomTypography
                                variant={"body2"}
                                label={customerData?.customer_name || "Guest Customer"}
                                sx={{ fontWeight: 700, color: theme.palette.typographyLabel.main, fontSize: '16px', mb: 0, maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                            />
                            {Boolean(customerData?.phone_number) && (
                                <CustomTypography
                                    variant={"body2"}
                                    label={`${customerData?.country_code ? `+${customerData?.country_code} ` : ''}${customerData?.phone_number}`}
                                    sx={{ color: theme.palette.typographyLabel.main, mt: 0.25, mb: 0, fontWeight: 400 }}
                                />
                            )}
                        </Box>
                    </Box>

                    {/* Right: EDIT button */}
                    <Button
                        variant="text"
                        size="small"
                        sx={{
                            color: theme.palette.primary.main,
                            fontWeight: 700,
                            minWidth: "auto",
                            p: 0,
                        }}
                        // onClick={() => {
                        //     if (orderType === ORDER_TYPES.TAKE_AWAY) {
                        //         window.dispatchEvent(
                        //             new CustomEvent("openTakeAwayDialog", {
                        //                 detail: customerData,
                        //             }),
                        //         )
                        //     } else if (orderType === ORDER_TYPES.DINE_IN) {
                        //         window.dispatchEvent(
                        //             new CustomEvent("openDineInDialog", {
                        //                 detail: customerData,
                        //             }),
                        //         )
                        //     } else if (orderType === ORDER_TYPES.TABLE_BOOKING) {
                        //         window.dispatchEvent(
                        //             new CustomEvent("openTableBookingDialog", {
                        //                 detail: customerData,
                        //             }),
                        //         )
                        //     }
                        // }}
                        onClick={reopenDialog}

                    >
                        EDIT
                    </Button>
                </Box>

                {/* Divider */}
                {orderType != ORDER_TYPES.TAKE_AWAY && <Divider sx={{ my: 0.5, borderColor: 'red' }} />}
                {/* {orderType !== ORDER_TYPES.TAKE_AWAY &&
                    (orderType !== ORDER_TYPES.PHONE_ORDER || Boolean(customerData?.customer_address)) &&
                    <Divider sx={{ my: 0.5 }} />
                } */}

                <Box className='d-flex align-items-center' gap={1.5} flexWrap={"wrap"}>
                    {/* Persons & Table row */}
                    {(orderType === ORDER_TYPES.DINE_IN || orderType === ORDER_TYPES.TABLE_BOOKING) && (
                        <>
                            <Box className='d-flex align-items-center'>
                                <PersonIcon fontSize="small" sx={{ color: theme.palette.drawermenuitem.main, width: '16px', height: '16px' }} />
                                <CustomTypography
                                    label={customerData?.persons}
                                    variant={"body2"}
                                    sx={{ mb: 0, color: theme.palette.drawermenuitem.main, lineHeight: 'revert', fontSize: '12px', }}
                                />
                            </Box>
                            <Box className='d-flex align-items-center'>
                                <TableRestaurantOutlinedIcon fontSize="small" sx={{ mr: 0.5, color: '#4D4D4D', width: '16px', height: '16px' }} />
                                <CustomTypography
                                    // label={`Table ${customerData?.table}`}
                                    label={customerData?.tableObj?.table_no}
                                    variant={"body2"}
                                    sx={{ mb: 0, color: theme.palette.drawermenuitem.main, lineHeight: 'revert', fontSize: '12px', }}
                                />
                            </Box>
                        </>
                    )}
                    {orderType === ORDER_TYPES.TABLE_BOOKING && (
                        <>
                            <Box className='d-flex align-items-center'>
                                <CalendarTodayOutlinedIcon fontSize="small" sx={{ mr: 0.5, color: '#4D4D4D', width: '13px', height: '13px' }} />
                                <CustomTypography
                                    label={`${customerData?.day}`}
                                    variant="body2"
                                    sx={{ color: theme.palette.drawermenuitem.main, fontSize: '12px', mb: 0, lineHeight: 'revert' }}
                                />
                            </Box>
                            <Box className='d-flex align-items-center'>
                                <WatchLaterOutlinedIcon fontSize="small" sx={{ mr: 0.5, color: '#4D4D4D', width: '16px', height: '16px' }} />
                                <CustomTypography
                                    label={`${customerData?.time}`}
                                    variant="body2"
                                    sx={{ color: theme.palette.drawermenuitem.main, fontSize: '12px', mb: 0, lineHeight: 'revert' }}
                                />
                            </Box>
                            <Box className='d-flex align-items-center'>
                                <Chip
                                    label={customerData?.time_slot}
                                    size="small"
                                    sx={{
                                        color: "#1F9619",
                                        bgcolor: "#EEF8EE",
                                        borderRadius: "5px",
                                        fontWeight: 600,
                                        fontSize: "12px",
                                        height: "21px",
                                        border: "transparent",
                                        "& .MuiChip-label": {
                                            px: 1.5,
                                            lineHeight: 1.2,
                                        },
                                    }}
                                    variant="outlined"
                                />
                                {/* <CustomTypography
                                    label={`${customerData?.time_slot}`}
                                    variant="body2"
                                    sx={{ color: theme.palette.drawermenuitem.main, fontWeight: '400', fontSize: '14px', mb: 0, lineHeight: 'revert' }}
                                /> */}
                            </Box>
                        </>
                    )}
                    {/* {orderType === ORDER_TYPES.PHONE_ORDER && customerData?.customer_address && (
                        <Box className='d-flex align-items-center'>
                            <CustomTypography
                                label={customerData?.customer_address}
                                variant="body2"
                                sx={{ color: theme.palette.drawermenuitem.main, fontSize: '12px', mb: 0, lineHeight: 'revert' }}
                            />
                        </Box>
                    )} */}
                </Box>
                {/* {orderType === ORDER_TYPES.TABLE_BOOKING && <Divider sx={{ my: 0.5, borderColor: 'red' }} />} */}
                {/* Date / Time line (only for booking) */}

            </CardContent>
        </Card>
    )
}

export default CustomerInfoCard
